export default {
    getDTCapacityKVA() {
        const dtCapacityKVA =
            [{ value: 100, text: 100 },
            { value: 160, text: 160 },
            { value: 250, text: 250 },
            { value: 250, text: 250 },
            { value: 500, text: 500 },
            { value: 1000, text: 1000 },
            { value: "others", text: "others" }]
        return dtCapacityKVA
    },
    getSecondaryVoltage() {
        const secondaryVoltage = [
            { value: 11, text: 11 },
            { value: 22, text: 22 },
            { value: 33, text: 33 },
            { value: "33/22/11 kva", text: "33/22/11 KVA" },
        ]
        return secondaryVoltage
    },
    getPrimaryVoltage() {
        const primaryVoltage = [
            { value: 11, text: 11 },
            { value: 22, text: 22 },
            { value: 33, text: 33 },
        ]
        return primaryVoltage
    },
    getStorageChargingDischargingStrategy() {
        const storageChargingDischargingStrategy = [
            { value: 'during_lowest_or_highest_marginal_cost', title: 'During lowest or highest marginal cost' },
            { value: 'during_lowest_or_highest_feeder_load_hours', title: 'Charging during low load hours - Discharging during high load hours' }
        ]
        return storageChargingDischargingStrategy
    },
    getProfileTypes() {
        const profileType = [
            { id: 1, title: "DT", value: "dt" },
            { id: 2, title: "Feeder", value: "feeder" },
            { id: 3, title: "State Level", value: "state_level" },
            { id: 4, title: "Substation", value: "substation" },
        ]
        return profileType
    },

    getMarginalCostSelectList() {
        const marginalCostSelectList = [
            { id: 0,value:'hourly_cost_of_supply_for_one_year', text: "Hourly cost of supply for one year" },
            { id: 1,value:'cost_as_per_iex_data',text: "Cost as per IEX data" },
            { id: 2,value:'marginal_cost_of_generator_to_be_replaced', text: "Marginal cost of generator that will be replaced" },
            { id: 3,value:'database',text: "Choose from Database" },
        ]
        return marginalCostSelectList
    },

    getInterconnectionLocationSolar() {
        const interconnectionLocationSolar =
            [{ shortName: 'sending_end', title: 'Sending End' },
            { shortName: 'middle_end', title: 'Middle End' },
            { shortName: 'tail_end', title: 'Tail End' }
        ]
        return interconnectionLocationSolar
    },
    getInterconnectionLocationStorage() {
        const interconnectionLocationStorage =
            [{ shortName: 'sending_end', title: 'Sending End' },
            { shortName: 'middle_end', title: 'Middle End' },
            { shortName: 'tail_end', title: 'Tail End' }
        ]
        return interconnectionLocationStorage
    }

}